var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScanner = function SvgScanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.75 8.5A3.75 3.75 0 0 1 8.5 4.75h7a3.75 3.75 0 0 1 3.75 3.75V9a.75.75 0 0 1-1.5 0v-.5a2.25 2.25 0 0 0-2.25-2.25h-7A2.25 2.25 0 0 0 6.25 8.5V9a.75.75 0 0 1-1.5 0zm0 7a3.75 3.75 0 0 0 3.75 3.75h7a3.75 3.75 0 0 0 3.75-3.75.75.75 0 0 0-1.5 0 2.25 2.25 0 0 1-2.25 2.25h-7a2.25 2.25 0 0 1-2.25-2.25zm-.5-4a.75.75 0 0 0 0 1.5h15.5a.75.75 0 0 0 0-1.5z",
    clipRule: "evenodd"
  })));
};
export default SvgScanner;